export default __webpack_public_path__ + "static/media/digna-tutorial-5.db72b283.gif";